export const RESET_PASSWORD_OPEN_MODAL = "RESET_PASSWORD_OPEN_MODAL";
export const RESET_PASSWORD_CLOSE_MODAL = "RESET_PASSWORD_CLOSE_MODAL";

export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_RESULT = "RESET_PASSWORD_RESULT";

